const COMPANY_NAME = {
    HTZ: 'HitechZone',
    RN: 'RailNinja',
    LS: 'LetStay',
    ELAL: 'Elal',
};

module.exports = {
    COMPANY_NAME,
};
